import React, { useRef, useLayoutEffect } from "react";

import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";

// MUI
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Utils
import { isValidArr } from "../../utility/utils";

type Props = {
  data: {
    category: string;
    count: number;
    percentageTxt: string;
  }[];
};

const FunnelChart = ({ data }: Props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const seriesRef = useRef<am5percent.FunnelSeries | null>(null);
  //   const legendRef = useRef<am5.Legend | null>(null);

  useLayoutEffect(() => {
    let root = am5.Root.new("funnelchartdiv");

    /* remove amchart logo */
    root._logo?.dispose();

    let chart = root.container.children.push(
      am5percent.SlicedChart.new(root, {
        layout: root.horizontalLayout,
      })
    );

    // Create series
    let series = chart.series.push(
      am5percent.FunnelSeries.new(root, {
        name: "Series",
        valueField: "count",
        categoryField: "category",
        orientation: "vertical",
        alignLabels: matches,
      })
    );

    series.labels.template.set(
      "text",
      matches ? "{category}: {percentageTxt}" : "{category}"
    );

    // To hide the labels form mobile and tab devices
    /* if (matches) {
      series.labels.template.set("text", "{category}: {percentageTxt}");
    } else {
      series.labels.template.set("forceHidden", true);
      series.ticks.template.set("forceHidden", true);
    } */

    series.slices.template.set("tooltipText", "{category}: {percentageTxt}");

    // Add legend
    /* let legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        y: am5.percent(50),
        layout: root.verticalLayout,
      })
    );

    legendRef.current = legend; */
    seriesRef.current = series;

    return () => {
      seriesRef.current = null;
      //   legendRef.current = null;
      root.dispose();
    };
  }, [matches]);

  useLayoutEffect(() => {
    if (isValidArr(data)) {
      seriesRef.current?.data.setAll(data);
      /* if (seriesRef.current) {
        legendRef.current?.data.setAll(seriesRef.current.dataItems);
      } */
    }
  }, [data]);

  return (
    <div id="funnelchartdiv" style={{ width: "100%", height: "100%" }}></div>
  );
};

export default FunnelChart;
